import React, {useEffect, useState} from "react"
import "./profile-dropdown.scss"
import {MdOutlinePowerSettingsNew} from "react-icons/md"
import ActionModal from "../../../common/modals/action-modal/ActionModal";
import {useNavigate} from 'react-router-dom'
import {useUser} from "../../../../providers/UserContext";
import ThemeButton from "../../../common/theme-button/ThemeButton";
import dayjs from "dayjs";
import {UserAuthService} from "../../../../services/user-auth-api.service";
import userIcon from "../../../../../assets/images/user.png"
import HeadingSkeleton from "../../../skeletons/HeadingSkeleton";

export default function ProfileDropdown(options) {
    const [profileData, setProfileData] = useState(false)
    const [logoutModal, setLogoutModal] = useState();
    const [loader, setLoader] = useState(false)
    const {handleLogout} = useUser()
    const navigate = useNavigate()
    const {user} = useUser()
    const {setProfileUpdate , profileUpdate} = useUser()

    const showLogout = () => {
        setLogoutModal(true)
    }
    const logout = () => {
        setLoader(true)
        setTimeout(()=>{
            handleLogout()
            navigate('/login')
            setLoader(false)
        },3000)
    }

    const lastLoginTime = dayjs(user?.additionalFields?.lastLoginAt);
    const now = dayjs();
    const diffInSeconds = now.diff(lastLoginTime, 'second');

    let timeAgo = '';

    if (diffInSeconds < 60) {
        timeAgo = `${diffInSeconds} second${diffInSeconds > 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < 3600) {
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        timeAgo = `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < 86400) {
        const diffInHours = Math.floor(diffInSeconds / 3600);
        timeAgo = `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
    } else {
        const diffInDays = Math.floor(diffInSeconds / 86400);
        timeAgo = `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
    }


    async function GetProfileData() {
        setLoader(true)
        const response = await UserAuthService.getProfileData();

        if(response?.data?.data?.status){
            setProfileData(response.data?.data?.data?.user)
            setLoader(false)
        }
    }

    useEffect(()=>{
        GetProfileData()
    },[ profileUpdate])

    return(
        <div className={'profile-dropdown'}>
            {
                loader ?
                    <HeadingSkeleton height={30} maxWidth={200}/> :
                    <div className={'profile-box'}>
                        <div className={'profile-avatar'}>
                            <img src={profileData?.profileImage ? profileData?.profileImage : userIcon} className={'img-fluid'}/>
                        </div>
                        <div className={'profile-content'}>
                            <h4>{profileData?.fullName}</h4>
                            <p> {timeAgo}</p>
                        </div>
                    </div>
            }

            <ThemeButton
                type={'button'}
                text={'View Profile'}
                className={'btn-light-lg mt-3'}
                route={'/my-profile'}
            />
            <div className={'profile-list'}>
                <ul>
                    <li>
                        <div className={'setting-box'} onClick={showLogout}>
                            <h5 className={'logout-text'}><i><MdOutlinePowerSettingsNew /></i> Logout</h5>
                        </div>
                    </li>
                </ul>
            </div>
            <ActionModal
                show={logoutModal}
                close={setLogoutModal}
                modalHeading={'Logout'}
                modalText={'Are you sure you want to logout this account?'}
                cancelBTnText={'Cancel'}
                actionBTnText={'Logout'}
                loader={loader}
                actionBtnFunc={() => {
                    logout()
                }}
            />
        </div>
    )
}